import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CSS_CONTACT_URL } from '../../../consts/consts';
import { TextButtonComponent } from '../../../ui/buttons/text-button/text-button.component';

@Component({
  selector: 'app-mp-access-restricted',
  standalone: true,
  imports: [TextButtonComponent],
  templateUrl: './mp-access-restricted.component.html',
  styleUrls: ['./mp-access-restricted.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpAccessRestrictedComponent {
  public contactCss(): void {
    window.open(CSS_CONTACT_URL, '_blank', 'noopener,noreferrer');
  }
}
